import { BaseComponent, BElement } from "utils/base-component"
import "./index.scss"

type ShareTranslations = {
  copied: string
  copy_link: string
  check_out_this_resort_snow_forecast: string
}

function getTranslations(): ShareTranslations {
  const dialog = document.getElementById("share-dialog") as HTMLDialogElement | null
  return {
    copied: dialog?.dataset.copied || "Copied!",
    copy_link: dialog?.dataset.copyLink || "Copy link",
    check_out_this_resort_snow_forecast:
      dialog?.dataset.checkOutThisResortSnowForecast || "Check out this resort on Snow-Forecast",
  }
}

export function copyToClipboard(button: BElement) {
  const translations = getTranslations()

  navigator.clipboard.writeText(window.location.href) // eslint-disable-line compat/compat
  const el = button.element
  el.textContent = translations.copied
  setTimeout(() => {
    el.textContent = translations.copy_link
  }, 3000)
}

async function shareVia(platform: string) {
  const translations = getTranslations()
  const { href: url } = window.location
  const { title } = document
  const strippedTitle = title.replace(/\| Snow-Forecast.com/, "").trim()
  const body = translations.check_out_this_resort_snow_forecast

  const shareUrls: Record<string, string> = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    x: `https://x.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(
      `${body} - ${title}`,
    )}`,
    linkedin: `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(
      `${body} - ${strippedTitle} - ${url}`,
    )}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(`${body} - ${title} - ${url}`)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(
      `${body} - ${title}`,
    )}`,
    reddit: `https://www.reddit.com/submit?url=${encodeURIComponent(
      url,
    )}&title=${encodeURIComponent(`${body} - ${title}`)}`,
  }

  const targetUrl = shareUrls[platform]
  if (targetUrl) window.open(targetUrl, "_blank", "noopener,noreferrer")
}

export class ShareModal extends BaseComponent {
  static cssClass = "share-modal"

  get dialog(): HTMLDialogElement {
    return this.root as HTMLDialogElement
  }

  private static scrollLockClass = "modal-open"

  init() {
    const copyButton = this.element("copy-button")
    copyButton?.element.addEventListener("click", () => {
      copyToClipboard(copyButton)
    })

    this.dialog.querySelectorAll("[data-share]").forEach((el) => {
      const platform = el.getAttribute("data-share")
      if (platform) el.addEventListener("click", () => shareVia(platform))
    })

    const closeButton = this.element("close-button")
    closeButton?.element.addEventListener("click", () => this.close())

    // Fallback for browsers that don't support closedby: close when clicking backdrop
    this.dialog.addEventListener("click", (e) => {
      if (e.target === this.dialog) this.close()
    })
    this.dialog.addEventListener("close", () => {
      document.documentElement.classList.remove(ShareModal.scrollLockClass)
    })
  }

  open() {
    this.dialog.showModal()
    document.documentElement.classList.add(ShareModal.scrollLockClass)
  }

  close() {
    this.dialog.close()
  }
}

export function showShareModal() {
  const dialog = document.getElementById("share-dialog") as HTMLDialogElement | null
  if (!dialog) return

  const instance = ShareModal.for(undefined, dialog)
  instance.open()
}
